// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/yasnoP2P/stylesheet/index.scss
 ** module id = 470
 ** module chunks = 1
 **/